import { TABLE_API_FAILURE, TABLE_API_FETCH, TABLE_API_SUCCESS, TABLE_API_UPDATE, TABLE_CLOSE, TABLE_CLOSE_ALL, TABLE_INIT, TABLE_INIT_REQUEST, TABLE_SUCCESS_REQUEST, TABLE_UPDATE } from './tables.action-types';
export var actions = {
  /**
   * Request table initiation.
   *
   * @author Mikhail Siutsou
   * @function tableInitRequest
   * @category Actions
   * @subcategory Tables
   * @param {TablePayload} payload payload.
   */
  tableInitRequest: function tableInitRequest(payload) {
    return {
      type: TABLE_INIT_REQUEST,
      payload: payload
    };
  },

  /**
   * Success Request table initiation.
   *
   * @author Mikhail Siutsou
   * @function tableSuccessRequest
   * @category Actions
   * @subcategory Tables
   * @param {TablePayload['tableId']} payload payload.
   */
  tableSuccessRequest: function tableSuccessRequest(payload) {
    return {
      type: TABLE_SUCCESS_REQUEST,
      payload: payload
    };
  },

  /**
   * Table initiation.
   *
   * @author Mikhail Siutsou
   * @function tableInit
   * @category Actions
   * @subcategory Tables
   * @param {TablePayload} payload payload.
   */
  tableInit: function tableInit(payload) {
    return {
      type: TABLE_INIT,
      payload: payload
    };
  },

  /**
   * Table update.
   *
   * @author Mikhail Siutsou
   * @function tableUpdate
   * @category Actions
   * @subcategory Tables
   * @param {TableUpdatePayload} payload payload.
   */
  tableUpdate: function tableUpdate(payload) {
    return {
      type: TABLE_UPDATE,
      payload: payload
    };
  },

  /**
   * Table api fetch.
   *
   * @author Mikhail Siutsou
   * @function tableApiFetch
   * @category Actions
   * @subcategory Tables
   * @param {TableApiFetchPayload} payload payload.
   */
  tableApiFetch: function tableApiFetch(payload) {
    return {
      type: TABLE_API_FETCH,
      payload: payload
    };
  },

  /**
   * Table api success fetch.
   *
   * @author Mikhail Siutsou
   * @function tableApiSuccess
   * @category Actions
   * @subcategory Tables
   * @param {TableApiSuccessPayload} payload payload.
   */
  tableApiSuccess: function tableApiSuccess(payload) {
    return {
      type: TABLE_API_SUCCESS,
      payload: payload
    };
  },

  /**
   * Table api fail fetch.
   *
   * @author Mikhail Siutsou
   * @function tableApiFailure
   * @category Actions
   * @subcategory Tables
   * @param {TableApiFailurePayload} payload payload.
   */
  tableApiFailure: function tableApiFailure(payload) {
    return {
      type: TABLE_API_FAILURE,
      payload: payload
    };
  },

  /**
   * Table api update.
   *
   * @author Mikhail Siutsou
   * @function tableApiUpdate
   * @category Actions
   * @subcategory Tables
   * @param {TableApiUpdatePayload} payload payload.
   */
  tableApiUpdate: function tableApiUpdate(payload) {
    return {
      type: TABLE_API_UPDATE,
      payload: payload
    };
  },

  /**
   * Table close.
   *
   * @author Mikhail Siutsou
   * @function tableClose
   * @category Actions
   * @subcategory Tables
   * @param {TableClosePayload} payload payload.
   */
  tableClose: function tableClose(payload) {
    return {
      type: TABLE_CLOSE,
      payload: payload
    };
  },

  /**
   * Tables close all.
   *
   * @author Mikhail Siutsou
   * @function tableCloseAll
   * @category Actions
   * @subcategory Tables
   */
  tableCloseAll: function tableCloseAll() {
    return {
      type: TABLE_CLOSE_ALL
    };
  }
};